import BookingsAdapter from './base';

export default class Booking extends BookingsAdapter {
  modelNamePlural = 'bookings';
}
